import { useState } from 'react'

import { Box, Button, Card, Divider, Text } from '@factorialco/deprecated-design-system'

import createComputed from 'modules/core/hooks/createComputed'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'
import { useGetMarketplaceCompanyInstallations } from 'modules/marketplace/hooks/integrations/companyInstallations/useGetMarketplaceCompanyInstallations'
import { DATEV_LAUDS_INTEGRATION_ID } from 'modules/marketplace/lib/integrationIds'

import DatevImporterCallout from 'modules/employees/components/EmployeesList/components/DatevImporterCallout'
import NotInvitedModal from './NotInvitedModal'
import PendingModal from './PendingModal'

const useEmployeesStats = createComputed((emp: Employee[]) => {
  return emp.reduce<[employeesPending: Employee[], employeesNotInvited: Employee[]]>(
    (acc, x) => {
      const [pending, notInvited] = acc
      const joined = employeeUser(x).attributes.confirmed
      const invited_on = employeeUser(x).invited_on

      if (x.isTerminated) return acc

      return [
        !!invited_on && !joined ? [...pending, x] : pending,
        !invited_on ? [...notInvited, x] : notInvited,
      ]
    },
    [[], []]
  )
})

const Header = () => {
  const { company } = useCurrentSession()
  const [isPendingModalHidden, setIsPendingModalHidden] = useState(true)
  const [isNotInvitedModalHidden, setIsNotInvitedModalHidden] = useState(true)
  const [employeesPending, employeesNotInvited] = useEmployeesStats(employees.toArray()).get()
  const { data: companyInstallationsData } = useGetMarketplaceCompanyInstallations(
    {
      companyIds: [company.id],
    },
    false
  )
  const hasDatevIntegration = companyInstallationsData?.some(
    (installation) => installation.integrationDatoId === DATEV_LAUDS_INTEGRATION_ID
  )
  const handlePendingModalClicked = () => {
    track(trackingEvents.employee.employeesSendInviteStart)
    setIsPendingModalHidden(!isPendingModalHidden)
  }

  const handleNotInvitedModalClicked = () => {
    track(trackingEvents.employee.employeesSendInviteStart)
    setIsNotInvitedModalHidden(!isPendingModalHidden)
  }
  return (
    <>
      {hasDatevIntegration && (
        <Box gap="s8" paddingBottom="s16">
          <DatevImporterCallout />
        </Box>
      )}
      <Box width="s400" flexGrow>
        <Card>
          <Card.Content>
            <Box flexDirection="column" width="full" gap="s16">
              <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
                <Text size="300" whiteSpace="nowrap">
                  {employeesPending.length} {i18n.t('employees.adming_header.pending_to_accept')}
                </Text>
                <Button
                  type="secondary"
                  onClick={() => handlePendingModalClicked()}
                  disabled={!employeesPending.length}
                  iconName="settings"
                />
              </Box>
              <Divider />
              <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
                <Text size="300" whiteSpace="nowrap">
                  {employeesNotInvited.length} {i18n.t('employees.adming_header.not_invited')}
                </Text>
                <Button
                  type="secondary"
                  onClick={() => handleNotInvitedModalClicked()}
                  disabled={!employeesNotInvited.length}
                  iconName="settings"
                />
              </Box>
            </Box>
          </Card.Content>
        </Card>
      </Box>
      <PendingModal
        isHidden={isPendingModalHidden}
        employees={employeesPending}
        onClose={() => setIsPendingModalHidden(true)}
      />
      <NotInvitedModal
        isHidden={isNotInvitedModalHidden}
        employees={employeesNotInvited}
        onClose={() => setIsNotInvitedModalHidden(true)}
      />
    </>
  )
}

export default Header
